// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071042/js/" + chunkId + "." + {"44":"cb1df420","225":"83456c2c","481":"327ea952","486":"5a0fe707","770":"1fa147a0"}[chunkId] + ".0.8381143167420836.chunk.js";
};